// extracted by mini-css-extract-plugin
module.exports = {"header":"powerup-intro-module--header--s_LyE","image":"powerup-intro-module--image--2rs9r","title":"powerup-intro-module--title--14l7R"};